/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconMathTg = createReactComponent("outline", "math-tg", "IconMathTg", [["path", { "d": "M7 8h4", "key": "svg-0" }], ["path", { "d": "M9 8v8", "key": "svg-1" }], ["path", { "d": "M18 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1", "key": "svg-2" }]]);

export { IconMathTg as default };
//# sourceMappingURL=IconMathTg.mjs.map
